import React from 'react'
import { Link } from 'react-router-dom'
import '../gift/GiftModal.css'

const GiftModal = () => {
  return (
   
    <div className='modal-box-sec gift-modal-sec'>
        <div className="modal fade" id="staticBackdrop10" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div class="modal-body">
                        <div className='head-gift position-relative text-center'>
                            <p>Send Chloe a gift</p>
                            <span className='gift-box'>
                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.5954 19.3817V9.92841H2.40479V19.3817C2.40479 20.2755 3.13422 20.9999 4.034 20.9999H17.9662C18.866 20.9999 19.5954 20.2755 19.5954 19.3817Z" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 20.9998V9.92523" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 7.3381V8.31032C21 9.20402 20.2706 9.92851 19.3708 9.92851H2.62921C1.72943 9.92851 1 9.20402 1 8.31032V7.3381C1 6.44441 1.72943 5.71991 2.62921 5.71991H19.3708C20.2706 5.71991 21 6.44441 21 7.3381Z" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.0006 5.71973C11.0006 4.30381 9.33747 1 6.84274 1C2.78418 1 4.26261 5.71973 6.20514 5.71973" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 5.71973C11 4.30381 12.6632 1 15.1579 1C19.2165 1 17.738 5.71973 15.7955 5.71973" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                            </span>
                        </div> 
                        <form action="">
                            <div className='form-group col-md-4'>
                                <label htmlFor="" className='d-none'></label>
                                <input type="text" className="form-control" id="" placeholder="00.00" />
                            </div>
                            <div className='form-group'>
                                <label htmlFor="" className='d-none'></label>
                                <textarea name="" id="" placeholder='Description'></textarea>
                            </div>
                            <div className='btn btn-group align-items-center m-auto d-flex justify-content-center'>
                                <Link rel='stylesheet' to="/" className='btn btn-border'>Send</Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default GiftModal
